import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../../api-config";

import { FaRegTrashCan } from "react-icons/fa6";


const AgentDetail = () => {
    const id = useParams().id;
    const [agent, setAgent] = useState({ tools: [] });
    const [availableTools, setAvailableTools] = useState([]);
    const [selectedTool, setSelectedTool] = useState("");
    const [description, setDescription] = useState("");
    const [type, setType] = useState("");
    const [dbList, setDbList] = useState([]);
    const [selectedDb, setSelectedDb] = useState("");

    const token = localStorage.getItem('token');

    useEffect(() => {
        // Fetch agent details
        axios.get(`${API_URL}/trading-api/agent/detail/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
        .then((response) => {
            setAgent(response.data);
            setDescription(response.data.description); // Initialize description
            setType(response.data.type); // Initialize type
            setSelectedDb(response.data.db_name); // Initialize selected database
        })
        .catch((error) => {
            console.error("There was an error fetching the agent data!", error);
        });

        // Fetch available tools
        axios.get(`${API_URL}/trading-api/agent/ls_function`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
        .then((response) => {
            setAvailableTools(response.data);
        })
        .catch((error) => {
            console.error("There was an error fetching the available tools!", error);
        });

        // Fetch database list
        axios.get(`${API_URL}/trading-api/agent/get_db_list`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
        .then((response) => {
            setDbList(response.data);
        })
        .catch((error) => {
            console.error("There was an error fetching the database list!", error);
        });

    }, [id, token]);

    const handleRemoveTool = async (toolName) => {
        try {
            const response = await axios.put(
                `${API_URL}/trading-api/agent/remove_function`,
                { id: agent.id, name: toolName },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.data.update) {
                setAgent((prevAgent) => ({
                    ...prevAgent,
                    tools: prevAgent.tools.filter(tool => tool !== toolName)
                }));
            }
        } catch (error) {
            console.error("Error removing tool:", error);
        }
    };

    const handleAddTool = async () => {
        if (!selectedTool) return;

        try {
            const response = await axios.put(
                `${API_URL}/trading-api/agent/add_function`,
                { id: agent.id, name: selectedTool },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.data.update) {
                setAgent((prevAgent) => ({
                    ...prevAgent,
                    tools: [...prevAgent.tools, selectedTool]
                }));
                setSelectedTool(""); // Reset the selection
            }
        } catch (error) {
            console.error("Error adding tool:", error);
        }
    };

    const handleUpdateDescription = async () => {
        try {
            const response = await axios.put(
                `${API_URL}/trading-api/agent/update_description/${id}`,
                { description },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.data.message) {
                alert("Description updated successfully!");
            }
        } catch (error) {
            console.error("Error updating description:", error);
        }
    };

    const handleUpdateType = async () => {
        try {
            const response = await axios.put(
                `${API_URL}/trading-api/agent/update_type/${id}`,
                { type },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.data.message) {
                alert("Type updated successfully!");
            }
        } catch (error) {
            console.error("Error updating type:", error);
        }
    };

    const handleUpdateDatabase = async () => {
        try {
            const response = await axios.put(
                `${API_URL}/trading-api/agent/update_database/${id}`,
                { db_name: selectedDb },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.data.message) {
                alert("Database updated successfully!");
                setAgent((prevAgent) => ({
                    ...prevAgent,
                    db_name: selectedDb
                }));
            }
        } catch (error) {
            console.error("Error updating database:", error);
        }
    };

    return (
      <div className='h-full w-screen p-4 flex-col'>
        <h1 className='text-xl font-bold mb-4'>Detalle del Agente</h1>
        <div className='shadow-md rounded-lg p-6 border flex align-left border-gray-300'>
          <div className="w-1/2">
            <p className='text-lg font-semibold'>Name:</p>
            <p className='mb-4'>{agent.name}</p>
    
            <p className='text-lg font-semibold'>Created By:</p>
            <p className='mb-4'>{agent.created_by}</p>

            <p className='text-lg font-semibold'>Database Name:</p>
            <select 
              value={selectedDb} 
              onChange={(e) => setSelectedDb(e.target.value)} 
              className="border rounded p-2 w-full mb-4 text-black"
            >
              {dbList.map((db, index) => (
                <option key={index} value={db}>{db}</option>
              ))}
            </select>
            <button
              onClick={handleUpdateDatabase}
              className="bg-blue-500
               text-white px-4 py-2 rounded hover:bg-purple-700"
            >
              Save Database
            </button>
    
            <p className='text-lg font-semibold mt-4'>Description:</p>
            <textarea
              className='border rounded p-2 w-full mb-4 text-black'
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              rows={6}
              placeholder="Enter the agent's description"
            />
            <button
              onClick={handleUpdateDescription}
              className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-700"
            >
              Save Description
            </button>
    
            <p className='text-lg font-semibold mt-4'>Type:</p>
            <select 
              value={type} 
              onChange={(e) => setType(e.target.value)} 
              className="border rounded p-2 w-full mb-4 text-black"
            >
              <option value="private">Private</option>
              <option value="public">Public</option>
            </select>
            <button
              onClick={handleUpdateType}
              className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-green-700"
            >
              Save Type
            </button>
          </div>
          <div className="w-1/2 px-24 py-2">
            <p className='text-lg font-semibold'>Tools:</p>
            <ul>
              {agent.tools.map((tool, index) => (
                <li key={index} className='flex items-center justify-around mb-2 border-2 p-1 rounded-full m-1'>
                  <span>{tool}</span>
                  <button onClick={() => handleRemoveTool(tool)} className='text-red-500 hover:text-red-700'>
                    <FaRegTrashCan className="text-white" />
                  </button>
                </li>
              ))}
            </ul>
            <div className="mt-4">
              <select 
                value={selectedTool} 
                onChange={(e) => setSelectedTool(e.target.value)} 
                className="border rounded p-2 w-full mb-2 text-black"
              >
                <option value="" disabled>Select a tool to add</option>
                {availableTools.map((tool, index) => (
                  <option key={index} value={tool}>{tool}</option>
                ))}
              </select>
              <button 
                onClick={handleAddTool} 
                className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-700"
              >
                Add Tool
              </button>
            </div>
          </div>
        </div>
      </div>
    );
};

export default AgentDetail;
